import React from "react";

export const Footer = () => {
    return (
        <footer>
            <span>&copy; by Aneta Maciejak</span>
        </footer>
    );
}